const ProgressBar = require('progressbar.js')

document.addEventListener('DOMContentLoaded', function () {
    var donuts = document.getElementsByClassName('progress-donut')
    var bars = document.getElementsByClassName('progress-bar')

    Array.from(donuts).forEach(donut => {
        const percent = donut.getAttribute('percent') || 0
        const colour = donut.getAttribute('colour') || 'pink'
        const percentFloat = percent / 100

        var bar = new ProgressBar.Circle(donut, {
            color: colour,
            strokeWidth: 8,
            trailWidth: 8,
            trailColor: '#bcbcbc',
            easing: 'easeInOut',
            duration: 1400,
            text: {
                autoStyleContainer: false
            },
            svgStyle: {
                strokeLinecap: 'round'
            },
            step: function (state, circle) {
                var value = Math.round(circle.value() * 100)
                value === 0 ? circle.setText('') : circle.setText(`${value}%`)
            }
        })
        bar.text.style.fontFamily = '"Raleway", Helvetica, sans-serif'
        bar.text.style.fontSize = '2.5rem'

        bar.animate(percentFloat)
    })

    Array.from(bars).forEach(bar => {
        const percent = bar.getAttribute('percent') || 0
        const colour = bar.getAttribute('colour') || 'pink'
        const fullWidth = bar.getAttribute('fullwidth') || false
        const percentFloat = percent / 100

        var pb = new ProgressBar.Line(bar, {
            strokeWidth: fullWidth ? 1.25 : 2.5,
            easing: 'easeInOut',
            duration: 1400,
            color: colour,
            trailColor: '#eee',
            trailWidth: fullWidth ? 1.25 : 2.5,
            svgStyle: { width: '100%', height: '100%', strokeLinecap: 'round' }
        })

        pb.animate(percentFloat)
    })
})
